export default "__VITE_PUBLIC_ASSET__01fe3abe__"